var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.toHome}},[(_vm.partnerCode==='apex_tz')?_c('span',{staticClass:"white--text text-h5"},[_vm._v("eMazao")]):_c('Logo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }